// Mock legal entity for ARISTEIA prototype.
// Replace with real data before production.
export const LEGAL_ENTITY = {
  name: "Aristeia Cultural SL",
  nif: "B-12345678",
  address: "Carrer de la Diputació 250, 4t 2a · 08007 Barcelona",
  email: "hola@aristeia.cat",
  phone: "+34 932 000 000",
  registry:
    "Registre Mercantil de Barcelona, Tom 47.812, Foli 122, Full B-578.193",
  domain: "aristeia.cat",
  dpo_email: "privacitat@aristeia.cat",
};

const E = LEGAL_ENTITY;
const LAST_UPDATE = "2026-02-15";

export const LEGAL = {
  ca: {
    last_update: `Última actualització: ${LAST_UPDATE}`,
    docs: {
      "legal-notice": {
        title: "Avís Legal",
        body: `**1. Dades identificatives**
En compliment de la Llei 34/2002, de 11 de juliol, de Serveis de la Societat de la Informació i del Comerç Electrònic (LSSI-CE), s'informa que el titular d'aquesta web és:

· Titular: ${E.name}
· NIF: ${E.nif}
· Domicili: ${E.address}
· Correu: ${E.email}
· Telèfon: ${E.phone}
· Inscripció: ${E.registry}

**2. Objecte**
Aquest lloc web ofereix informació i reserves d'experiències culturals organitzades per ${E.name} a Catalunya.

**3. Condicions d'ús**
L'usuari es compromet a fer un ús lícit, diligent i de bona fe del lloc, abstenint-se d'introduir continguts contraris a les lleis o als drets de tercers.

**4. Propietat intel·lectual**
Els continguts, marca, logotips i fotografies són propietat de ${E.name} o dels seus titulars legítims i estan protegits per la normativa de propietat intel·lectual.

**5. Responsabilitat**
${E.name} no es fa responsable dels danys derivats d'un mal ús del lloc ni d'errors de tercers aliens al seu control.

**6. Llei aplicable**
La llei aplicable serà la legislació espanyola i la jurisdicció competent la dels Jutjats i Tribunals de Barcelona.`,
      },
      privacy: {
        title: "Política de Privacitat",
        body: `**Responsable del tractament**
· ${E.name} — NIF ${E.nif}
· Adreça: ${E.address}
· Correu: ${E.email}
· Delegat de Protecció de Dades: ${E.dpo_email}

**Finalitats del tractament**
1. Gestió del registre d'usuaris i autenticació.
2. Gestió de reserves, pagaments i facturació de les experiències.
3. Comunicacions transaccionals (confirmacions, recordatoris) i, si l'usuari hi consent, butlletí d'experiències.
4. Anàlisi anònima d'ús del web per millorar el servei.

**Base legal**
· Execució del contracte de reserva.
· Compliment d'obligacions legals (facturació, comptabilitat).
· Consentiment, en el cas del màrqueting i les cookies no essencials.

**Termini de conservació**
Les dades es conserven mentre existeixi relació contractual i, posteriorment, durant els terminis legals aplicables (mercantil, fiscal). Les dades de màrqueting fins a la revocació del consentiment.

**Destinataris**
Es comuniquen exclusivament les dades necessàries a:
· Holded (ERP, facturació) — UE.
· Stripe / RedSys (passarel·la de pagament).
· Proveïdor d'enviament de correus transaccionals.

No es realitzen transferències internacionals fora de l'EEE sense garanties adequades.

**Drets de l'usuari**
Accés, rectificació, supressió, limitació, oposició i portabilitat, així com a revocar el consentiment, exercitant-los al correu ${E.dpo_email}. També podeu reclamar davant l'Autoritat Catalana de Protecció de Dades (apdcat.gencat.cat) o l'AEPD (aepd.es).

**Mesures de seguretat**
S'apliquen mesures tècniques i organitzatives adequades (xifratge en trànsit, autenticació amb tokens, control d'accés) per garantir la confidencialitat i la integritat de les dades.`,
      },
      cookies: {
        title: "Política de Cookies",
        body: `Aquest lloc utilitza cookies, pròpies i de tercers, per al seu correcte funcionament i per analitzar la navegació.

**Què és una cookie**
Petits fitxers de text que el navegador desa al teu dispositiu i que ens permeten reconèixer-te en visites posteriors.

**Tipologies utilitzades**
· **Tècniques (sempre actives)**: necessàries per al funcionament del lloc, la sessió i la seguretat. Inclouen el token d'autenticació i la preferència d'idioma.
· **Analítiques (consentiment)**: ens permeten conèixer el comportament d'ús del lloc de manera agregada. Es desactiven si no s'accepten.
· **Funcionals (consentiment)**: recorden preferències com el motiu de visita o continguts vistos. Es desactiven si no s'accepten.

**Gestió del consentiment**
La primera vegada que entres mostrem un avís que permet acceptar totes, rebutjar les no essencials o personalitzar la teva tria. Pots canviar la teva opció en qualsevol moment des de "Perfil → Cookies" o esborrant les cookies del navegador.

**Termini**
Les cookies tècniques duren la sessió. Les analítiques i funcionals com a màxim 12 mesos.

**Tercers**
Es poden utilitzar serveis de tercers com Google Analytics o YouTube (vídeo de portada). Cadascun té la seva pròpia política, accessible des dels seus llocs.

**Contacte**
Per a qualsevol dubte: ${E.email}.`,
      },
      terms: {
        title: "Termes i Condicions",
        body: `**1. Objecte**
Aquestes condicions regulen la reserva i la prestació d'experiències culturals comercialitzades per ${E.name} a través del lloc ${E.domain}.

**2. Procés de reserva**
La reserva es perfecciona amb el pagament a través de la passarel·la integrada. L'usuari rep una confirmació per correu amb el detall de la jornada.

**3. Preu**
Els preus mostrats són per persona i inclouen IVA. La capacitat de cada experiència és limitada i s'assigna per ordre de reserva.

**4. Cancel·lacions i canvis**
· Cancel·lació amb més de 14 dies: reemborsament del 100%.
· Entre 14 i 7 dies: 50%.
· Menys de 7 dies o no presentar-se: sense reemborsament.
· En cas de cancel·lació per part de ${E.name} (climatologia, força major), reemborsament íntegre.

**5. Responsabilitat**
${E.name} actua com a organitzador i no es fa responsable d'accidents derivats d'una conducta imprudent del participant. Es recomana calçat adequat i respectar les indicacions dels guies.

**6. Propietat intel·lectual**
El nom, logotip i continguts són propietat de ${E.name}. La seva reproducció requereix autorització expressa.

**7. Llei aplicable i jurisdicció**
Llei espanyola i Jutjats i Tribunals de Barcelona.`,
      },
    },
  },
  es: {
    last_update: `Última actualización: ${LAST_UPDATE}`,
    docs: {
      "legal-notice": {
        title: "Aviso Legal",
        body: `**1. Datos identificativos**
En cumplimiento de la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y del Comercio Electrónico (LSSI-CE), se informa de que el titular de este sitio web es:

· Titular: ${E.name}
· NIF: ${E.nif}
· Domicilio: ${E.address}
· Correo: ${E.email}
· Teléfono: ${E.phone}
· Inscripción: ${E.registry}

**2. Objeto**
Este sitio ofrece información y reservas de experiencias culturales organizadas por ${E.name} en Catalunya.

**3. Condiciones de uso**
El usuario se compromete a hacer un uso lícito, diligente y de buena fe del sitio, absteniéndose de introducir contenidos contrarios a las leyes o a los derechos de terceros.

**4. Propiedad intelectual**
Los contenidos, marca, logotipos y fotografías son propiedad de ${E.name} o de sus titulares legítimos, y están protegidos por la normativa de propiedad intelectual.

**5. Responsabilidad**
${E.name} no se hace responsable de los daños derivados de un mal uso del sitio ni de errores de terceros ajenos a su control.

**6. Ley aplicable**
Ley española y jurisdicción de los Juzgados y Tribunales de Barcelona.`,
      },
      privacy: {
        title: "Política de Privacidad",
        body: `**Responsable del tratamiento**
· ${E.name} — NIF ${E.nif}
· Dirección: ${E.address}
· Correo: ${E.email}
· Delegado de Protección de Datos: ${E.dpo_email}

**Finalidades del tratamiento**
1. Gestión del registro de usuarios y autenticación.
2. Gestión de reservas, pagos y facturación de las experiencias.
3. Comunicaciones transaccionales (confirmaciones, recordatorios) y, con consentimiento, boletín de experiencias.
4. Análisis anónimo de uso del sitio para mejorar el servicio.

**Base legal**
· Ejecución del contrato de reserva.
· Cumplimiento de obligaciones legales (facturación, contabilidad).
· Consentimiento, en el caso de marketing y cookies no esenciales.

**Plazo de conservación**
Los datos se conservan mientras exista relación contractual y, posteriormente, durante los plazos legales aplicables (mercantil, fiscal). Los datos de marketing hasta la revocación del consentimiento.

**Destinatarios**
Se comunican exclusivamente los datos necesarios a:
· Holded (ERP, facturación) — UE.
· Stripe / RedSys (pasarela de pago).
· Proveedor de envío de correos transaccionales.

No se realizan transferencias internacionales fuera del EEE sin garantías adecuadas.

**Derechos del usuario**
Acceso, rectificación, supresión, limitación, oposición y portabilidad, así como revocar el consentimiento, ejercitándolos en el correo ${E.dpo_email}. Puede reclamar ante la Autoridad Catalana de Protección de Datos (apdcat.gencat.cat) o la AEPD (aepd.es).

**Medidas de seguridad**
Se aplican medidas técnicas y organizativas adecuadas (cifrado en tránsito, autenticación por tokens, control de acceso) para garantizar la confidencialidad e integridad de los datos.`,
      },
      cookies: {
        title: "Política de Cookies",
        body: `Este sitio utiliza cookies, propias y de terceros, para su correcto funcionamiento y para analizar la navegación.

**¿Qué es una cookie?**
Pequeños archivos de texto que el navegador guarda en tu dispositivo y que nos permiten reconocerte en visitas posteriores.

**Tipologías utilizadas**
· **Técnicas (siempre activas)**: necesarias para el funcionamiento del sitio, la sesión y la seguridad. Incluyen el token de autenticación y la preferencia de idioma.
· **Analíticas (consentimiento)**: nos permiten conocer el comportamiento de uso del sitio de forma agregada. Se desactivan si no se aceptan.
· **Funcionales (consentimiento)**: recuerdan preferencias como el motivo de visita o contenidos vistos. Se desactivan si no se aceptan.

**Gestión del consentimiento**
La primera vez que entras mostramos un aviso que permite aceptar todas, rechazar las no esenciales o personalizar tu elección. Puedes cambiar tu opción en cualquier momento desde "Perfil → Cookies" o borrando las cookies del navegador.

**Plazo**
Las cookies técnicas duran la sesión. Las analíticas y funcionales como máximo 12 meses.

**Terceros**
Pueden utilizarse servicios de terceros como Google Analytics o YouTube (vídeo de portada). Cada uno tiene su propia política, accesible desde sus sitios.

**Contacto**
Para cualquier duda: ${E.email}.`,
      },
      terms: {
        title: "Términos y Condiciones",
        body: `**1. Objeto**
Estas condiciones regulan la reserva y la prestación de experiencias culturales comercializadas por ${E.name} a través del sitio ${E.domain}.

**2. Proceso de reserva**
La reserva se perfecciona con el pago a través de la pasarela integrada. El usuario recibe una confirmación por correo con el detalle de la jornada.

**3. Precio**
Los precios mostrados son por persona e incluyen IVA. La capacidad de cada experiencia es limitada y se asigna por orden de reserva.

**4. Cancelaciones y cambios**
· Cancelación con más de 14 días: reembolso del 100%.
· Entre 14 y 7 días: 50%.
· Menos de 7 días o no presentarse: sin reembolso.
· En caso de cancelación por parte de ${E.name} (climatología, fuerza mayor), reembolso íntegro.

**5. Responsabilidad**
${E.name} actúa como organizador y no se hace responsable de accidentes derivados de una conducta imprudente del participante. Se recomienda calzado adecuado y respetar las indicaciones de los guías.

**6. Propiedad intelectual**
Nombre, logotipo y contenidos son propiedad de ${E.name}. Su reproducción requiere autorización expresa.

**7. Ley aplicable y jurisdicción**
Ley española y Juzgados y Tribunales de Barcelona.`,
      },
    },
  },
  en: {
    last_update: `Last update: ${LAST_UPDATE}`,
    docs: {
      "legal-notice": {
        title: "Legal Notice",
        body: `**1. Identifying details**
In compliance with Spanish Law 34/2002 (LSSI-CE), the owner of this website is:

· Owner: ${E.name}
· VAT/NIF: ${E.nif}
· Address: ${E.address}
· Email: ${E.email}
· Phone: ${E.phone}
· Registration: ${E.registry}

**2. Purpose**
This website offers information about and bookings for cultural experiences organised by ${E.name} in Catalonia.

**3. Terms of use**
Users undertake to use the site lawfully, diligently and in good faith, refraining from publishing content contrary to law or to third-party rights.

**4. Intellectual property**
Content, brand, logos and photography are owned by ${E.name} or by their respective rights holders and are protected by intellectual property regulations.

**5. Liability**
${E.name} is not responsible for damages arising from misuse of the site or from third-party errors outside its control.

**6. Applicable law**
Spanish law and the Courts of Barcelona.`,
      },
      privacy: {
        title: "Privacy Policy",
        body: `**Data controller**
· ${E.name} — VAT ${E.nif}
· Address: ${E.address}
· Email: ${E.email}
· Data Protection Officer: ${E.dpo_email}

**Purposes**
1. User registration and authentication.
2. Booking, payment and invoicing of experiences.
3. Transactional communications (confirmations, reminders) and, with consent, an experiences newsletter.
4. Anonymous analytics to improve the service.

**Legal basis**
· Performance of the booking contract.
· Compliance with legal obligations (invoicing, accounting).
· Consent, in the case of marketing and non-essential cookies.

**Retention period**
Data is retained while the contractual relationship exists and, subsequently, for the legal periods required (commercial, fiscal). Marketing data until consent is revoked.

**Recipients**
Only the data strictly required is shared with:
· Holded (ERP, invoicing) — EU.
· Stripe / RedSys (payment gateway).
· Transactional email provider.

No international transfers outside the EEA are made without adequate safeguards.

**User rights**
Access, rectification, erasure, restriction, objection and portability, and the right to withdraw consent — exercised by writing to ${E.dpo_email}. You may also file a complaint with the Catalan Data Protection Authority (apdcat.gencat.cat) or the Spanish AEPD (aepd.es).

**Security measures**
We apply appropriate technical and organisational measures (in-transit encryption, token authentication, access control) to ensure confidentiality and integrity.`,
      },
      cookies: {
        title: "Cookie Policy",
        body: `This site uses first-party and third-party cookies for its proper operation and to analyse browsing behaviour.

**What is a cookie**
Small text files stored by your browser that allow us to recognise you on subsequent visits.

**Types used**
· **Strictly necessary (always on)**: required for the site to work, for the session and for security. Includes the authentication token and language preference.
· **Analytics (consent)**: aggregated browsing behaviour. Disabled unless accepted.
· **Functional (consent)**: remember preferences such as your visit motive or recently viewed content. Disabled unless accepted.

**Consent management**
On your first visit we show a banner allowing you to accept all, reject the non-essential ones or customise your choice. You can update your choice at any time from "Profile → Cookies" or by clearing your browser cookies.

**Duration**
Strictly-necessary cookies last for the session. Analytics and functional cookies last a maximum of 12 months.

**Third parties**
We may use third-party services such as Google Analytics or YouTube (cover video). Each has its own policy on their site.

**Contact**
For any question: ${E.email}.`,
      },
      terms: {
        title: "Terms & Conditions",
        body: `**1. Purpose**
These terms govern bookings and the provision of cultural experiences sold by ${E.name} via ${E.domain}.

**2. Booking process**
A booking is confirmed upon payment via the integrated gateway. The user receives an email confirmation with the day's details.

**3. Price**
Prices are per person and include VAT. Capacity per experience is limited and assigned in order of booking.

**4. Cancellations & changes**
· More than 14 days: 100% refund.
· Between 14 and 7 days: 50%.
· Less than 7 days or no-show: no refund.
· If cancelled by ${E.name} (weather, force majeure): full refund.

**5. Liability**
${E.name} acts as the organiser and is not liable for accidents arising from reckless behaviour of the participant. Proper footwear is recommended; please follow the guides' instructions.

**6. Intellectual property**
Name, logo and content are owned by ${E.name}. Reproduction requires written permission.

**7. Applicable law & jurisdiction**
Spanish law and the Courts of Barcelona.`,
      },
    },
  },
};
